var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 16.6153846 18",
        fill: "currentColor",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "MacBook-Pro-13-Copy-4",
                transform: "translate(-472.500000, -246.500000)",
                "fill-rule": "nonzero",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "поиск",
                    transform: "translate(121.000000, 180.000000)",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group",
                        transform: "translate(338.000000, 26.000000)",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "calendar",
                            transform: "translate(13.500000, 40.500000)",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M15.2307692,1.38461538 L13.1538462,1.38461538 L13.1538462,0.692307692 C13.1538462,0.309956712 12.8438894,0 12.4615385,0 C12.0791875,0 11.7692308,0.309956712 11.7692308,0.692307692 L11.7692308,1.38461538 L4.84615385,1.38461538 L4.84615385,0.692307692 C4.84615385,0.309956712 4.53619713,0 4.15384615,0 C3.77149517,0 3.46153846,0.309956712 3.46153846,0.692307692 L3.46153846,1.38461538 L1.38461538,1.38461538 C0.619913423,1.38461538 0,2.00452881 0,2.76923077 L0,16.6153846 C0,17.3800866 0.619913423,18 1.38461538,18 L15.2307692,18 C15.9954712,18 16.6153846,17.3800866 16.6153846,16.6153846 L16.6153846,2.76923077 C16.6153846,2.00452881 15.9954712,1.38461538 15.2307692,1.38461538 Z M3.46153846,2.76923077 L3.46153846,3.46153846 C3.46153846,3.84388944 3.77149517,4.15384615 4.15384615,4.15384615 C4.53619713,4.15384615 4.84615385,3.84388944 4.84615385,3.46153846 L4.84615385,2.76923077 L11.7692308,2.76923077 L11.7692308,3.46153846 C11.7692308,3.84388944 12.0791875,4.15384615 12.4615385,4.15384615 C12.8438894,4.15384615 13.1538462,3.84388944 13.1538462,3.46153846 L13.1538462,2.76923077 L15.2307692,2.76923077 L15.2307692,5.53846154 L1.38461538,5.53846154 L1.38461538,2.76923077 L3.46153846,2.76923077 Z M15.2307692,16.6153846 L1.38461538,16.6153846 L1.38461538,6.92307692 L15.2307692,6.92307692 L15.2307692,16.6153846 Z M6.9230771,9 L6.9230771,14.5384615 C6.9230771,14.9208125 6.61312021,15.2307692 6.23076923,15.2307692 C5.84841825,15.2307692 5.53846154,14.9208125 5.53846154,14.5384615 L5.53846154,10.1198077 L5.15596154,10.3119231 C4.81375741,10.4830251 4.39764053,10.3443195 4.22653846,10.0021154 C4.0554364,9.65991126 4.19414203,9.24379437 4.53634615,9.07269231 L5.92096154,8.38038462 C6.13564872,8.272955 6.3906662,8.2844135 6.5948536,8.41066409 C6.79904101,8.53691468 6.92324886,8.75993401 6.9230771,9 L6.9230771,9 Z M12.0426923,11.6350962 L10.3846154,13.8461538 L11.7692308,13.8461538 C12.1515817,13.8461538 12.4615493,14.1561106 12.4615493,14.5384615 C12.4615493,14.9208125 12.1515817,15.2307692 11.7692308,15.2307692 L9,15.2307692 C8.73777319,15.2307692 8.49805257,15.0826137 8.38078118,14.848071 C8.26350978,14.6135282 8.28881776,14.3328584 8.44615385,14.1230769 L10.9367308,10.8025962 C11.0910884,10.5971033 11.1189061,10.3230121 11.0089819,10.0906972 C10.8990576,9.8583822 10.6694841,9.70608059 10.4127088,9.6951231 C10.1559336,9.68416562 9.9142198,9.81635577 9.78490385,10.0384615 C9.66479998,10.2596414 9.43412153,10.3982165 9.18244554,10.4003754 C8.93076956,10.4025344 8.69774779,10.2679369 8.57386722,10.04885 C8.44998666,9.82976315 8.45476478,9.56070408 8.58634615,9.34615385 C9.05653388,8.53248635 10.0144912,8.13591729 10.9222144,8.37916602 C11.8299375,8.62241474 12.4612261,9.44486478 12.4615493,10.3846154 C12.4630064,10.8361237 12.3158173,11.2755623 12.0426923,11.6350962 L12.0426923,11.6350962 Z",
                              id: "Shape",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }